import React from 'react';

const LeadsStatusesDatabaseContext = React.createContext({});
LeadsStatusesDatabaseContext.displayName = 'LeadsStatusesDatabaseContext';

export default LeadsStatusesDatabaseContext;
